//This file is used for maintain JavaScript functions that are bound to a particular scope or view
(function(module) {
  'use strict';
  module
    .controller('providerController', ['$scope', 'authService', '$sce', 'providers', '$stateParams', 'progressBar', 'ngDialog',
      'uiGridConstants', 'commonDialog', 'commonDialogMessage', '$state', 'fileReader',
      function($scope, authService, $sce, providers, $stateParams, progressBar, ngDialog, uiGridConstants, commonDialog,
        commonDialogMessage, $state, fileReader) {
        let readyToUpload = false;
        let selectedFilename = null;
        const progress = progressBar.getProgressBar();
        $scope.viewData = {};
        $scope.provider = {
          Id: 0,
          Code: null,
          IATACode: null,
          ImageLink: '//:0',
          LoginTitle: null,
          Name: null,
          ProviderType: null,
          Login2Code: null,
          Login2Title: null,
          Login3Code: null,
          Login3Title: null,
        };
        $scope.isEdit = false;
        $scope.isIATACode = false;
        let gridData;
        $scope.providerTypeList = [{
          id: 4,
          name: 'Select a Provider Type',
        }, {
          id: 0,
          name: 'All',
        }, {
          id: 1,
          name: 'Flight',
        }, {
          id: 2,
          name: 'Car',
        }, {
          id: 3,
          name: 'Hotel',
        }, ];
        $scope.typeId = 4;
        let id = $stateParams.id;
        if (!!id) {
          if (id > 1) {
            getProviderById(providers.getProviderById(id));
          } else {
            getProviderById(providers.getProviders());
          }
          $scope.isEdit = true;
        };

        function getProviderById(fn) {
          progress.start();
          fn.then(function(provider) {
              $scope.isEdit = true;
              $scope.provider = provider.data;
              $scope.typeId = provider.data.ProviderType;
              if ($scope.typeId == 1) {
                $scope.isIATACode = true;
              } else {
                $scope.isIATACode = false;
              }
            }, function(err) {
              if (err.status != 401) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = `<p>${err.statusText}</p>`;
                    $scope.errTitle = 'Get provider Error';
                  },],
                });
              }
            })
            .finally(function() {
              progress.complete();
            });
        };
        $scope.getFile = function() {
          fileReader.readAsDataUrl($scope.file, $scope)
            .then(function(result) {
              $scope.provider.ImageLink = result;
            });
        };
        $scope.saveProvider = function() {
          if ($scope.providerForm.$valid) {
            $scope.provider.ProviderType = $scope.typeId;
            if ($scope.provider.ProviderType != 1) {
              $scope.provider.IATACode = '';
            }
            if (($scope.isIATACode && !$scope.provider.IATACode ) || $scope.typeId == 4 || !$scope.provider.Code) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>${commonDialogMessage.iataCodeError}</p>`;
                  $scope.errTitle = 'IATA Code Warning';
                },],
              });
            } else {
              progress.start();
              if (readyToUpload) {
                // pipe raw to cloudinary, retrieve transformed cloudinary url and replace ImageLink
                uploadImage(selectedFilename).then(function(result) {
                  if (result != null) {
                    $scope.provider.ImageLink = result;
                    addProvider($scope.provider);
                  }
                });
              } else {
                $scope.provider.ImageLink = null;
                addProvider($scope.provider);
              }
            };
          }
        };

        function addProvider(provider) {
          providers.addProvider(provider).then(function () {
            const dialogPost = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Add Provider Success';
                $scope.successMsg = 'The provider has been added succesfully.';
              },],
            });
            dialogPost.closePromise.then(function (data) {
              $scope.clearAll();
              $state.go('app.providers');
            });
          }, function (err) {
            if (err.status != 401) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>${err.statusText}</p>`;
                  $scope.errTitle = 'Save provider Error';
                },],
              });
            }
          })
            .finally(function () {
              progress.complete();
            });
        };
        $scope.clearAll = function() {
          $scope.organizations = {};
          $scope.isEdit = false;
          $scope.isNew = false;
          $scope.provider = {};
          $scope.img_url = {};
          $scope.providerForm.$setPristine();
          $scope.typeId = 4;
        };
        $scope.updateProvider = function(id) {
          if ($scope.providerForm.$valid) {
            let provider = $scope.provider;
            provider.ProviderType = $scope.typeId;
            if (provider.ProviderType != 1) {
              provider.IATACode = '';
            }
            console.log($scope.isIATACode, !$scope.provider.IATACode, $scope.typeId, $scope.provider.Code);
            if (($scope.isIATACode && !$scope.provider.IATACode) || $scope.typeId == 4 || !$scope.provider.Code) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>${commonDialogMessage.iataCodeError}</p>`;
                  $scope.errTitle = 'IATA Code Warning';
                },],
              });
            } else {
              progress.start();
              if (readyToUpload) {
                // pipe raw to cloudinary, retrieve transformed cloudinary url and replace ImageLink
                uploadImage(selectedFilename).then(function(result) {
                  if (result != null) {
                    provider.ImageLink = result;
                    putProvider(provider);
                  }
                });
              } else {
                provider.ImageLink = null;
                putProvider(provider);
              }
            };
          };
        };

        function putProvider(provider) {
          providers.updateProvider(provider.Id, provider).then(function(provider) {
            const dialogPost = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Update Provider Success';
                $scope.successMsg = 'The provider has been updated succesfully.';
              },],
            });
            dialogPost.closePromise.then(function (data) {
              $scope.clearAll();
              $state.go('app.providers');
            });
            }, function(err) {
              if (err.status != 401) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = `<p>${err.statusText} </p>`;
                    $scope.errTitle = 'Update provider Error';
                  },],
                });
              }
            })
            .finally(function() {
              progress.complete();
            });
        }
        $scope.providerTypeStateChange = function() {
          if ($scope.typeId == 1) {
            $scope.isIATACode = true;
          } else {
            $scope.isIATACode = false;
          }
        };
        $scope.checkExt = function() {
          if ((/\.(gif|jpe?g|png|svg)$/i).test($scope.provider.ImageLink)) {
            $scope.validExt = true;
          } else {
            $scope.validExt = false;
          }
        };
        $scope.fetchLogo = function() {
          if ($scope.validExt) {
            $scope.popover = true;
          }
        };
        $scope.setFile = function(event) {
          selectedFilename = event.target.files[0];
          readyToUpload = true;
          $scope.provider.filename = selectedFilename.name;
          fileReader.readAsDataUrl(selectedFilename, $scope)
            .then(function(result) {
              $scope.provider.ImageLink = result;
            });
          $scope.$apply();
        };
        $scope.clearFile = function() {
          readyToUpload = false;
          selectedFilename = null;
          $scope.provider.filename = null;
          $scope.provider.ImageLink = '//:0';
          //$scope.$apply();
        };
        // Attach this method to <button id="save"...> to test Cloudinary chained upload/transform capabilities
        $scope.testUpload = function() {
          uploadImage(selectedFilename).then(function(result) {
            console.log(result);
          });
        };

        function uploadImage(img) {
          if (img != null) {
            return providers.uploadImage(img).then(function(result) {
              const cloudinaryObj = result.data;
              const public_filename = cloudinaryObj.public_id + '.' + cloudinaryObj.format; // e.g. 'filename.jpg'
              return providers.transformImage(public_filename).then(function(result) {
                return result.data;
              });
            });
          }
        };
        //ui-grid code
        const paginationOptions = {
          pageNumber: 1,
          pageSize: 25,
          sort: null,
        };
        $scope.gridOptions = {
          paginationPageSizes: [5, 10, 25, 50],
          enableFiltering: true,
          enableGridMenu: true,
          paginationPageSize: 25,
          useExternalPagination: false,
          useExternalSorting: false,
          enableColumnResizing: true,
          enableRowSelection: true,
          enableSelectAll: false,
          enableRowHeaderSelection: false,
          multiSelect: false,
          columnDefs: [{
            name: 'Name',
            visible: true,
            enableSorting: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
            cellTemplate: '<div><div ng-if="!!row.entity.ImageLink" style="display: inline-flex;"><div style="padding-left:5px;" ><a><img style="display:inline-block;max-width:18px;max-height:18px;margin:0 5px 0 5px;" ng-src="{{row.entity.ImageLink}}"></a>{{row.entity.Icon}}</div> <div> {{row.entity.Name}}</div></div><div style="padding-left:32px;" ng-if="!row.entity.ImageLink">{{row.entity.Name}}</div></div>',
            sort: {
              direction: uiGridConstants.ASC,
              priority: 0,
            },
          }, {
            name: 'Code',
            enableHiding: false,
            enableSorting: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'IATACode',
            displayName: 'IATA Code',
            enableHiding: false,
            enableSorting: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'ProviderType',
            visible: true,
            enableSorting: true,
            enableColumnResizing: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            maxWidth: 250,
            cellTemplate: '<span style="padding-left: 5px;"> {{grid.appScope.setProviderType(row.entity.ProviderType)}}</span>',
            filter: {
              type: uiGridConstants.filter.SELECT,
              selectOptions: [{
                value: '0',
                label: 'All',
              }, {
                value: '1',
                label: 'Flight',
              }, {
                value: '2',
                label: 'Car',
              }, {
                value: '3',
                label: 'Hotel',
              }, {
                value: '4',
                label: 'Expense',
              }, {
                value: '5',
                label: 'Test',
              }, {
                value: '6',
                label: 'Partner',
              }, ],
            },
          }, {
            name: 'LoginTitle',
            enableSorting: false,
            visible: true,
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'Login2Code',
            visible: false,
            enableSorting: false,
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'Login2Title',
            visible: false,
            enableSorting: false,
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'Login3Code',
            visible: false,
            enableSorting: false,
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'Login3Title',
            visible: false,
            enableSorting: false,
            enableColumnResizing: true,
            maxWidth: 250,
          }, ],
          rowTemplate: '<div ng-dblclick="grid.appScope.onDblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" ui-grid-cell ></div>',
          onRegisterApi: function(gridApi) {
            $scope.gridApi = gridApi;
            $scope.gridApi.core.on.sortChanged($scope, function(grid, sortColumns) {
              if (!sortColumns.length) {
                paginationOptions.sort = null;
              } else {
                paginationOptions.sort = sortColumns[0].sort.direction;
              }
              updateGridPagination(gridData);
            });
            gridApi.pagination.on.paginationChanged($scope, function(newPage, pageSize) {
              paginationOptions.pageNumber = newPage;
              paginationOptions.pageSize = pageSize;
              updateGridPagination(gridData);
            });
            gridApi.selection.on.rowSelectionChanged($scope, function(row) {
              $scope.rowSelectingId = row.entity.Id;
              if (row.isSelected) {
                $scope.rowSelecting = true;
              } else {
                $scope.rowSelecting = false;
              }
            });
          },
        };
        $scope.onDblClick = function(row) {
          $scope.rowSelectingId = row.entity.Id;
          $scope.view(row.entity);
          // Override default rowSelection action
          row.isSelected = true;
          $scope.rowSelecting = true;
        };

        function updateGridPagination(gridData) {          
          $scope.gridOptions.data = gridData;
          $scope.gridOptions.totalItems = gridData.length;
        };
        function setGridData() {
          progress.start();
          if(authService.getLoginMember().Role === 4) {
            providers.getProvidersByAdmin().then(function(provider) {
                gridData = provider.data;
                updateGridPagination(provider.data);
              }, function(err) {
                if (err.status != 401) {
                  ngDialog.open({
                    template: 'templates/partials/viewErrorMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function ($scope) {
                      $scope.errMsg = `<p>${err.statusText}</p>`;
                      $scope.errTitle = 'Provider Error';
                    },],
                  });
                }
              })
              .finally(function() {
                progress.complete();
              });
          } else {
            providers.getProviders().then(function(provider) {
                gridData = provider.data;
                updateGridPagination(provider.data);
              }, function(err) {
                if (err.status != 401) {
                  ngDialog.open({
                    template: 'templates/partials/viewErrorMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function ($scope) {
                      $scope.errMsg = `<p>${err.statusText}</p>`;
                      $scope.errTitle = 'Provider Error';
                    },],
                  });
                }
              })
              .finally(function() {
                progress.complete();
              });
          }
        };
        setGridData();
        $scope.view = function(rowEntity) {
          const selectedRow = !!rowEntity ? rowEntity : $scope.gridApi.selection.getSelectedRows()[0];
          if (!!selectedRow) {
            $scope.viewData.name = selectedRow.Name;
            $scope.viewData.code = selectedRow.Code;
            $scope.viewData.login2Code = selectedRow.Login2Code;
            $scope.viewData.login3Code = selectedRow.Login3Code;
            $scope.viewData.providerType = $scope.setProviderType(selectedRow.ProviderType);
            $scope.viewData.loginTitle = selectedRow.LoginTitle;
            $scope.viewData.login2Title = selectedRow.Login2Title;
            $scope.viewData.login3Title = selectedRow.Login3Title;
            $scope.viewData.IATACode = selectedRow.IATACode;
            $scope.viewData.imageLink = selectedRow.ImageLink;
            const view = ngDialog.open({
              template: 'templates/partials/viewProvider.html',
              className: 'ngdialog-theme-plain',
              scope: $scope,
            });
            view.closePromise.then(function(data) {
              $scope.viewData = {};
            });
          }
        };
        $scope.deleteProvider = function() {
          const confirm = ngDialog.open({
            template: 'templates/partials/viewConfirm.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.strTitle = 'Delete Provider?';
              $scope.strMsg = 'Do you really want to delete this provider?';
            },],
          });
          confirm.closePromise.then(function(data) {
            if ($scope.rowSelectingId && data.value === 1) {
              progress.start();
              providers.deleteProvider($scope.rowSelectingId).then(function(response) {
                  const dialog = ngDialog.open({
                    template: 'templates/partials/viewSuccessMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function ($scope) {
                      $scope.strTitle = 'Delete Provider Success';
                      $scope.successMsg = 'The provider has been succesfully deleted.';
                    },],
                  });
                  dialog.closePromise.then(function(data) {});
                }, function(err) {
                  if (err.status != 401) {
                    const dialog = ngDialog.open({
                      template: 'templates/partials/viewErrorMsg.html',
                      className: 'ngdialog-theme-plain',
                      controller: ['$scope', function ($scope) {
                        $scope.errMsg = `<p>${err.statusText}</p>`;
                        $scope.errTitle = 'Delete Provider Error';
                      },],
                    });
                    dialog.closePromise.then(function(data) {});
                  }
                })
                .finally(function() {
                  progress.complete();
                  $scope.gridApi.core.clearAllFilters();
                  setGridData();
                });
            }
          });
        };
        $scope.edit = function() {
          $state.go('app.editProvider', {
            id: $scope.rowSelectingId,
          });
        };
        $scope.setProviderType = function(typeId) {
          let providerType = null;
          switch (typeId) {
            case 0:
              providerType = 'All';
              break;
            case 1:
              providerType = 'Flight';
              break;
            case 2:
              providerType = 'Car';
              break;
            case 3:
              providerType = 'Hotel';
              break;
            default:
              providerType = '';
              break;
          }
          return providerType;
        };
      },
    ]);
})(angular.module('obex'));


// WEBPACK FOOTER //
// ./client/js/controllers/providerController.js